import React from 'react'
import LayoutContainer from 'components/Common/LayoutContainer'
import LuxPlusLandingBenefitsList from './LuxPlusLandingBenefitsList'
import LuxPlusActivityTable from './LuxPlusActivityTable'
import LuxPlusDestinationCarousel from './LuxPlusDestinationCarousel'
import LuxPlusLandingPartnerOffersSection from './LuxPlusLandingPartnerOffersSection'
import LuxPlusLandingOfferCarousels from './LuxPlusLandingOfferCarousels'
import LuxPlusLandingFaqSection from './LuxPlusLandingFaqSection'

function LuxPlusLoggedInBenefitsTabSection() {
  return (<>
    <LuxPlusLandingBenefitsList />

    <LayoutContainer>
      <LuxPlusActivityTable />
    </LayoutContainer>

    <LuxPlusDestinationCarousel />

    <LuxPlusLandingOfferCarousels />
    <LayoutContainer>
      <LuxPlusLandingPartnerOffersSection />
    </LayoutContainer>
    <LuxPlusLandingFaqSection />
  </>)
}

export default LuxPlusLoggedInBenefitsTabSection
